<div class="w-auto h-auto">
    <div class="flex justify-between mb-0 h-5 ml-3 mt-3">
        <h5 class="text-base font-bold tracking-tight text-gray-900 truncate w-11/12" title="{{data?.data?.job_name}}">
            <span class="route-color mr-3"
                [ngStyle]="{'background-color': data?.data?.color || '#1abc9c'}"></span>{{data?.data?.job_name}}
        </h5>
    </div>
    <div class="flex flex-col my-1 px-3">
        <div *ngIf="data?.data?.customer?.customer_first_name" class="text-base my-2"><span class="font-semibold">{{'text.customer_name' | translate}}:
            </span>{{data?.data?.customer?.customer_first_name}}
            {{data?.data?.customer?.customer_last_name ?? ''}}
        </div>
        <div class="text-base my-2"><span class="font-semibold">{{'ppm.details.content.job_location' | translate}}:
            </span>{{utilityService.getFormattedAddress(data?.data?.customer_address)}}</div>
    </div>
</div>